import { render, staticRenderFns } from "./RaPet.vue?vue&type=template&id=21436a60&scoped=true"
import script from "./RaPet.vue?vue&type=script&lang=js"
export * from "./RaPet.vue?vue&type=script&lang=js"
import style0 from "./RaPet.vue?vue&type=style&index=0&id=21436a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21436a60",
  null
  
)

export default component.exports